// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-box {
  position: absolute;
  top: 40px;
  right: 0;
  width: 280px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 12px;
  z-index: 100;
  color: #333;
}
.notification-box .notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid #eee;
}
.notification-box .notification-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}
.notification-box .notification-header .mark-all-read-text {
  color: var(--primary-color);
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.notification-box .notification-header .mark-all-read-text:hover {
  text-decoration: underline;
}
.notification-box .notification-scroll-container {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 4px;
}
.notification-box .notification-scroll-container .notification-item {
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}
.notification-box .notification-scroll-container .notification-item:hover {
  background-color: #e2e8f0;
}
.notification-box .notification-scroll-container .notification-item .notif-per-item {
  padding: 6px 12px;
}
.notification-box .notification-scroll-container .notification-item .timestamp {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}
.notification-box .notification-scroll-container .notification-item:last-child {
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Notifications/Notifications.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uCAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AACF;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;AAAJ;AAGI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AADN;AAKI;EACE,2BAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAHN;AAKM;EACE,0BAAA;AAHR;AASE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAPJ;AAUI;EACE,gCAAA;EACA,eAAA;AARN;AAWM;EACE,yBAAA;AATR;AAaM;EACE,iBAAA;AAXR;AAeM;EACE,eAAA;EACA,WAAA;EACA,eAAA;AAbR;AAiBM;EACE,mBAAA;AAfR","sourcesContent":[".notification-box {\r\n  position: absolute;\r\n  top: 40px;\r\n  right: 0;\r\n  width: 280px;\r\n  background: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  padding: 12px;\r\n  z-index: 100;\r\n  color: #333;\r\n\r\n\r\n  .notification-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n    padding-bottom: 6px;\r\n    border-bottom: 1px solid #eee;\r\n\r\n\r\n    h4 {\r\n      margin: 0;\r\n      font-size: 16px;\r\n      font-weight: 600;\r\n    }\r\n\r\n\r\n    .mark-all-read-text {\r\n      color: var(--primary-color);\r\n      font-size: 13px;\r\n      cursor: pointer;\r\n      white-space: nowrap;\r\n     \r\n      &:hover {\r\n        text-decoration: underline;\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  .notification-scroll-container {\r\n    max-height: 300px;\r\n    overflow-y: auto;\r\n    padding-right: 4px;\r\n\r\n\r\n    .notification-item {\r\n      border-bottom: 1px solid #f0f0f0;\r\n      cursor: pointer;\r\n\r\n\r\n      &:hover {\r\n        background-color: #e2e8f0;\r\n      }\r\n\r\n\r\n      .notif-per-item {\r\n        padding: 6px 12px;\r\n      }\r\n\r\n\r\n      .timestamp {\r\n        font-size: 12px;\r\n        color: #888;\r\n        margin-top: 4px;\r\n      }\r\n\r\n\r\n      &:last-child {\r\n        border-bottom: none;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
